import { readableText, lightTint } from "../utils/themeContrast";
import React from "react";
import useWindowDimensions from "../hooks/useWindowDimensions";
import styled from "@emotion/styled";
import { IoSearchOutline, IoCloseOutline } from "react-icons/io5";
import { UserContext, ActionContext, ThemeContext } from "../contexts/Context";

const CategorySearch = ({ sidebar = false }) => {
  const { width } = useWindowDimensions();
  const desktopField = sidebar && width >= 768;
  const { isSearching, searchTxt } = React.useContext(UserContext);
  const { setIsSearch, setSearching, setSearchTxt } = React.useContext(ActionContext);
  const theme = React.useContext(ThemeContext);
  const openSearch = () => {
    if (!isSearching) {
      setIsSearch(true);
      setSearching(true);
    }
  };
  const closeSearch = () => {
    setSearchTxt("");
    setIsSearch(false);
    setSearching(false);
  };
  return (
    <SearchArea expanded={isSearching || desktopField} desktopField={desktopField} themeContext={theme}>
      {isSearching || desktopField ? <>
        <IoSearchOutline size={18} aria-hidden="true" />
        <input autoFocus={!desktopField} onFocus={openSearch} aria-label="Search the menu" placeholder="Search the menu" value={searchTxt || ""}
          onChange={event => { openSearch(); setSearchTxt(event.target.value); }}
          onKeyDown={event => { if (event.key === "Escape") closeSearch(); }} />
        {isSearching && <button type="button" aria-label="Close search" onClick={closeSearch}><IoCloseOutline size={20} /></button>}
      </> : <button type="button" aria-label="Search menu" onClick={openSearch}>
        <IoSearchOutline size={20} />
      </button>}
    </SearchArea>
  );
};
export default CategorySearch;

const SearchArea = styled.div`
  display: flex;
  flex: ${props => props.expanded ? "1 1 auto" : "0 0 36px"};
  min-width: 0;
  height: 50px;
  align-items: center;
  gap: 8px;
  color: ${props => readableText(props.themeContext.backgroundColor, props.themeContext.descriptionColor, props.themeContext.fontPrimary)};
  font-family: ${props => props.themeContext.fontFamily};
  input { flex: 1; min-width: 0; width: 100%; border: 0; outline: none; background: transparent; color: inherit; font: inherit; font-size: 14px; }
  input::placeholder { color: inherit; opacity: 0.75; }
  button { display: flex; flex: 0 0 32px; align-items: center; justify-content: center; height: 40px; padding: 0; border: 0; background: transparent; color: inherit; cursor: pointer; }
  ${props => props.desktopField && `
    height: 48px;
    padding: 0 18px;
    box-sizing: border-box;
    gap: 12px;
    border: 1px solid ${lightTint(props.themeContext.primaryColor, .25)};
    border-radius: 999px;
    background: ${lightTint(props.themeContext.primaryColor, .07)};
    color: ${readableText(lightTint(props.themeContext.primaryColor, .07), props.themeContext.primaryColor, props.themeContext.fontPrimary)};
    input { font-size: 15px; }
    input::placeholder { color: inherit; opacity: 1; }
    > svg { flex-shrink: 0; width: 20px; height: 20px; }
    &:focus-within { border-color: ${props.themeContext.primaryColor}; }
  `}
  button:focus-visible { outline: 2px solid ${props => props.themeContext.primaryColor}; border-radius: 4px; }
`;
